<template>
  <div class="d-inline copySubscribersButton">
    <button
      class="actionButton"
      title="Copy Subscribers"
      @click="onOpenModal"
    >
      Copy Subscribers
    </button>
    <copy-subscribers-modal :campaign-id="campaignId" :shown="modalShown" @close-modal="onCloseModal"></copy-subscribers-modal>
  </div>
</template>

<script>
import CopySubscribersModal from './CopySubscribersModal';

export default {
  name: 'copy-subscribers-button',
  components: {CopySubscribersModal},
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      modalShown: false,
    };
  },
  methods: {
      onOpenModal() {
          this.modalShown = true;
      },
      onCloseModal() {
          this.modalShown = false;
      }
  }
};
</script>
